<script>
import {useLikeStore} from "@js/store/LikeStore.js";
import {useCatalogStore} from "@js/store/CatalogStore.js";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import CatalogProductItemGrid from "@js/components/Sections/Catalog/Components/CatalogProductItemGrid.vue";
import CatalogProductItemWide from "@js/components/Sections/Catalog/Components/CatalogProductItemWide.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import CatalogProductSkeleton from "@js/components/Sections/Catalog/Components/CatalogProductSkeleton.vue";
import IconHeartFilled from "@js/components/Icons/IconHeartFilled.vue";

export default {
    name: "LikedProductsPage",
    components: {
        IconHeartFilled,
        CatalogProductSkeleton,
        OnlyMobile,
        CatalogProductItemWide,
        CatalogProductItemGrid,
        OnlyDesktop,
        Breadcrumbs,
        MobileTopBar

    },
    mounted() {
        this.likeStore.getLikedProductsData()
    },
    setup() {
        const likeStore = useLikeStore()
        const catalogStore = useCatalogStore()

        return {likeStore, catalogStore}
    }
}
</script>

<template>
    <MobileTopBar/>
    <div class="container">
        <Breadcrumbs/>
        <h1 class="flex items-center text-2xl font-bold mb-5">
            Избранные продукты
        </h1>
        <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
            <template v-if="!likeStore.loading_products"
                      v-for="(product, key) in likeStore.products" :key="product.id">
                <OnlyDesktop>
                    <CatalogProductItemGrid :data="product"/>
                </OnlyDesktop>
                <OnlyMobile>
                    <CatalogProductItemWide :data="product"/>
                </OnlyMobile>
            </template>
            <template v-else v-for="i in 4">
                <OnlyDesktop>
                    <CatalogProductSkeleton variant="grid"/>
                </OnlyDesktop>
                <OnlyMobile>
                    <CatalogProductSkeleton variant="wide"/>
                </OnlyMobile>
            </template>
        </div>
        <div v-if="!likeStore.loading_products && !likeStore.products.length">
            <div
                class="flex flex-col items-center justify-center w-full bg-white p-5 border border-gray-200 shadow rounded-xl">
                <div class="flex items-center justify-center border border-gray-200 rounded-full p-4 md:p-5 mb-5">
                    <IconHeartFilled class="w-7 h-7 text-red-600"/>
                </div>
                <div class="text-xl md:text-2xl font-bold text-gray-800 text-center mb-2">
                    У вас пока нет избранных товаров
                </div>
                <div class="text-sm md:text-base font-bold text-gray-800 text-center">
                    Перейдите в каталог и добавьте товары в избранное
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
